import { render } from "./Application.vue?vue&type=template&id=774615f4&scoped=true&ts=true"
import script from "./Application.vue?vue&type=script&lang=ts"
export * from "./Application.vue?vue&type=script&lang=ts"

import "./Application.vue?vue&type=style&index=0&id=774615f4&scoped=true&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774615f4"],['__file',"src/views/Application.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "774615f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('774615f4', __exports__)) {
    console.log('reload')
    api.reload('774615f4', __exports__)
  }
  
  module.hot.accept("./Application.vue?vue&type=template&id=774615f4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('774615f4', render)
  })

}


export default __exports__